import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { MessageDetailPage } from '@apps/web/components/messages/message_detail_page';
import { useDeepLinkOrganization } from '@apps/web/hooks/use_deep_link_organization';

const messageDetailsSearchSchema = z.object({
    organizationId: z.string().optional(),
    mode: z.enum(['live', 'sandbox']).optional(),
});

export const Route = createFileRoute(
    '/_app/(main)/outreaches/message/$message-id',
)({
    head: () => ({
        meta: [
            {
                title: 'Message Details | Phoebe',
            },
        ],
    }),
    validateSearch: messageDetailsSearchSchema,
    component: MessageDetailComponent,
});

function MessageDetailComponent() {
    const { 'message-id': messageId } = Route.useParams();
    const { organizationId: deepLinkOrganizationId, mode: deepLinkMode } =
        Route.useSearch();
    const { isWaitingForDeepLinkOrganization } = useDeepLinkOrganization(
        deepLinkOrganizationId,
        deepLinkMode,
    );

    if (isWaitingForDeepLinkOrganization) {
        return null;
    }

    return <MessageDetailPage messageId={messageId} />;
}
